import { doRequest } from './URLUtils';

const trackStop = (key) => {
    const url = `/frontend-home/service/metrics/stopMetric/${key}`;
    doRequest(url, { method: 'POST' });
};

export const MetricUtils = {
    trackStop,
};
